/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import client from '../../../api/client';

import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import BtnGogo from '../../../components/buttongoto/ButtonGoto';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import { orderStatus } from '../library';
import { colors } from '../../../helper/constant';

function MyShop_Seller_History(props) {
  const shopId = props.permitdata?.shop_id;
  const [selected_month, setSelected_month] = useState(moment(new Date()).format('YYYY-MMM'));
  const [myorder_list, setorder_list] = useState([]);
  const [orderselect, setorderselect] = useState({});
  const [shipping_timeline, setshipping_timeline] = useState({});
  const [modal_delivery_timeline, setmodal_delivery_timeline] = useState(false);
  const [timelineRequest, setTimelineRequest] = useState(null);

  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {}

  const onChangemonth = (date, dateString) => {
    if (dateString !== '') {
      setSelected_month(dateString);
    }
  };

  const historyQuery = useQuery({
    queryKey: ['order-history', shopId, selected_month, 'seller'],
    queryFn: async () => {
      await sleep(200);
      const start_time = selected_month + '-01 00:00:00';
      const stop_time = moment(new Date(start_time)).add(1, 'month').format('YYYY-MMM-DD 00:00:00');

      const formData = new FormData();
      formData.append('start_time', start_time);
      formData.append('stop_time', stop_time);
      formData.append('shop_id', shopId);
      formData.append('shop_side', 'seller_shopid');

      const response = await client.post('/api/order/myshop/common/historyquery', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      if (response.data.status !== 'OK') {
        const err = new Error(response.data.message || 'historyquery failed');
        err.isWarning = true;
        throw err;
      }
      return response.data.order || [];
    },
    enabled: !!shopId && selected_month !== '',
  });

  const timelineQuery = useQuery({
    queryKey: ['order-timeline', timelineRequest?.tracking_code, timelineRequest?.nonce],
    queryFn: async () => {
      await sleep(200);
      const formData = new FormData();
      formData.append('tracking_code', timelineRequest.tracking_code);

      const response = await client.post('/api/order/myshop/common/timelinetracking', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      if (response.data.status !== 'OK') {
        const err = new Error(response.data.message || 'timelinetracking failed');
        err.isWarning = true;
        throw err;
      }
      return response.data.timeline;
    },
    enabled: !!timelineRequest,
  });

  useEffect(() => {
    let activeOrders = [];
    if (props.data_shoporder_seller_all && selected_month !== '') {
      const startOpt = moment(selected_month + '-01 00:00:00');
      const endOpt = moment(selected_month + '-01 00:00:00').add(1, 'month');
      activeOrders = props.data_shoporder_seller_all.filter((o) => {
        if (!o.createtime) return false;
        const d = moment(o.createtime);
        return d.isSameOrAfter(startOpt) && d.isBefore(endOpt);
      });
    }
    const apiOrders = historyQuery.data ?? [];
    const merged = [...activeOrders, ...apiOrders];
    merged.sort((a, b) => moment(b.createtime).diff(moment(a.createtime)));
    setorder_list(merged);
  }, [historyQuery.data, props.data_shoporder_seller_all, selected_month]);

  useEffect(() => {
    if (historyQuery.isFetching) {
      setmodal_load({ enable: true, message: 'กำลังโหลดประวัติการขายย้อนหลัง' });
    } else if (timelineQuery.isFetching) {
      setmodal_load({ enable: true, message: 'กำลังเรียกดูข้อมูล' });
    } else {
      setmodal_load({ enable: false, message: '' });
    }
  }, [historyQuery.isFetching, timelineQuery.isFetching]);

  useEffect(() => {
    if (!historyQuery.isError) return;
    setmodal_load({ enable: false, message: '' });
    setModal_popup({
      modaltype: historyQuery.error?.isWarning ? 'modal-warning' : 'modal-error',
      headers: historyQuery.error?.isWarning ? 'ขออภัย' : 'ผิดพลาด',
      message: historyQuery.error?.message ?? 'ผิดพลาด',
      enable: true,
    });
  }, [historyQuery.isError, historyQuery.error]);

  useEffect(() => {
    if (!timelineRequest) return;

    if (timelineQuery.isSuccess && timelineQuery.data) {
      setmodal_load({ enable: false, message: '' });
      setshipping_timeline(timelineQuery.data);
      if (timelineRequest.order) {
        setorderselect(timelineRequest.order);
      }
      setmodal_delivery_timeline(true);
      setTimelineRequest(null);
      return;
    }

    if (timelineQuery.isError) {
      setmodal_load({ enable: false, message: '' });
      const err = timelineQuery.error;
      setModal_popup({
        modaltype: err?.isWarning ? 'modal-warning' : 'modal-error',
        headers: err?.isWarning ? 'ขออภัย' : 'ผิดพลาด',
        message: err?.message ?? 'ผิดพลาด',
        enable: true,
      });
      setTimelineRequest(null);
    }
  }, [
    timelineRequest,
    timelineQuery.isSuccess,
    timelineQuery.isError,
    timelineQuery.data,
    timelineQuery.error,
  ]);

  const [itemOffset_onsell, setItemOffset_onsell] = useState(0);
  const endOffset_onsell = itemOffset_onsell + 18;
  const currentItems_onsell = myorder_list.slice(itemOffset_onsell, endOffset_onsell);
  const pageCount_onsell = Math.ceil(myorder_list.length / 18);
  const handlePageClick_onsell = (event) => {
    const newOffset_onsell = (event.selected * 18) % myorder_list.length;
    setItemOffset_onsell(newOffset_onsell);
  };

  function api_deliver_timelinetracking(tracking_code, order) {
    setTimelineRequest({ tracking_code, order, nonce: Date.now() });
  }

  return (
    <div className='my-0 font-inter font-th'>
      <div className='row px-3'>
        <div className='form-group' style={{ minWidth: '200px' }}>
          <label className='font-th' htmlFor='chart_year'>
            เลือกเดือน
          </label>
          <DatePicker
            allowClear={false}
            picker='month'
            onChange={onChangemonth}
            format={'YYYY-MMM'}
            className={'form-control-sm'}
            defaultValue={dayjs(new Date(selected_month + '-01'))}
          />
        </div>
      </div>

      <div className='row'>
        {myorder_list.length > 0 ? (
          currentItems_onsell.map((order, index0) => (
          <div className='col-md-12 mb-md-2 mb-lg-0' key={order.order_id}>
            <div className='card-mycart mb-2'>
              <div className='card-mycart-header modern light-theme'>
                <div className='d-flex justify-content-between align-items-center w-100 flex-wrap gap-2'>
                  <div className='d-flex align-items-center gap-3'>
                    <div className='bg-white rounded-circle d-flex align-items-center justify-content-center' style={{ width: '40px', height: '40px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
                      <i className='font-size-18 fas fa-store text-primary'></i>
                    </div>
                    <div className='d-block'>
                      <div className='card-mycart-title mb-0'>
                        {order.buyer_shopname}
                      </div>
                      <div className='card-mycart-subtitle'>
                        <i className='fas fa-map-marker-alt mr-1'></i> {order.buyer_shopprovince}
                      </div>
                    </div>
                  </div>
                  <div className='d-flex flex-column align-items-end'>
                    <div className='order-id-label mb-1'>
                      ORD: {order.order_id}
                    </div>
                    {orderStatus(order, 'seller')}
                  </div>
                </div>
              </div>
              <div className='card-mycart-body'>
                <div className='d-block d-md-flex justify-content-between pt-0 pb-2 flex-wrap'>
                  <div className='d-block'>
                    {order.orderitem !== null
                      ? order.orderitem.map((orderitems, index1) => (
                          <div
                            className={
                              'd-block ' +
                              (order.order_status === 'PC_RTN_RCV' ? 'd-xl-flex ' : ' d-md-flex ') +
                              (index1 > 0 ? 'border-top py-1' : 'py-1')
                            }
                            key={orderitems.orderitem_id}
                          >
                            <div className='d-flex'>
                              <div className='mycart-box-image'>
                                <img
                                  className='img-fluid max-width-100 p-1 border border-color-1'
                                  src={
                                    `${process.env.REACT_APP_IMAGE_URL}` +
                                    orderitems.productitem_id +
                                    '/' +
                                    orderitems.productitem_id +
                                    '-1-' +
                                    orderitems.img1_key +
                                    '.jpg'
                                  }
                                  alt={orderitems.orderitem_id}
                                />
                              </div>
                              <div className='d-block product-detail'>
                                <div className='mycart-box-productname py-0'>
                                  {orderitems.productitem_name}
                                </div>
                                <div className='mycart-box-productinter py-0'>
                                  {orderitems.productitem_inter}
                                </div>
                              </div>
                            </div>
                            <div className='mycart-box-pricelist'>
                              <table>
                                <tbody className='d-block mt-0'>
                                  {orderitems.orderitem_pricelist !== null
                                    ? orderitems.orderitem_pricelist.map((pricelist, index1) => (
                                        <tr
                                          className='mycart-table-pricelist-row py-0'
                                          key={pricelist.pricelist_id}
                                          style={{ paddingTop: '0px' }}
                                        >
                                          <td className='product-unit'>
                                            ชุด {pricelist.unit} ชิ้น
                                          </td>
                                          <td className='product-stock'>
                                            Exp.{' '}
                                            {dayjs(new Date(pricelist.expire)).format(
                                              'DD MMM BBBB',
                                            )}
                                          </td>
                                          <td className='product-quantity'>
                                            x {pricelist.select} ชุด
                                          </td>
                                          <td className='product-subtotal'>
                                            ฿{' '}
                                            {pricelist.subtotal.toLocaleString(undefined, {
                                              maximumFractionDigits: 0,
                                              minimumFractionDigits: 0,
                                            })}
                                          </td>
                                          {order.order_status === 'PC_RTN_RCV' ? (
                                            <>
                                              <td className='product-quantity text-danger'>
                                                คืน x {pricelist.return_select} ชิ้น
                                              </td>
                                              <td className='product-subtotal text-danger'>
                                                ฿{' '}
                                                {pricelist.return_subtotal.toLocaleString(
                                                  undefined,
                                                  {
                                                    maximumFractionDigits: 0,
                                                    minimumFractionDigits: 0,
                                                  },
                                                )}
                                              </td>
                                            </>
                                          ) : null}
                                        </tr>
                                      ))
                                    : null}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ))
                      : null}
                  </div>
                  <div className='d-block mt-2 mb-5 mb-md-2' style={{ minWidth: '250px' }}>
                    <div className='d-flex justify-content-between py-0'>
                      <div className='table-summary-cell'>มูลค่าสินค้า</div>
                      <div className='table-summary-cellt'>
                        ฿{' '}
                        {Number(order.shop_subtotal).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                    <div className='d-flex justify-content-between py-0'>
                      <div className='table-summary-cell'>ค่าขนส่ง</div>
                      <div className='table-summary-cell aligh-right'>
                        ฿{' '}
                        {Number(order.shop_shipping_markup).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                    {parseFloat(order.summary_discount) > 0 ? (
                      <div className='d-flex justify-content-between py-0'>
                        <div className='table-summary-cell text-danger'>ส่วนลด</div>
                        <div className='table-summary-cell aligh-right text-danger'>
                          - ฿{' '}
                          {Number(order.summary_discount).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          })}
                        </div>
                      </div>
                    ) : null}
                    {order.coupon_id ? (
                      <div className='d-flex justify-content-between py-0'>
                        <div className='table-summary-cell text-muted' style={{ fontSize: '11px' }}>
                          โค้ดส่วนลด
                        </div>
                        <div className='table-summary-cell aligh-right text-muted' style={{ fontSize: '11px' }}>
                          🏷️ {order.coupon_id}
                        </div>
                      </div>
                    ) : null}
                    <div className='d-flex justify-content-between py-0 border-bottom'>
                      <div className='table-summary-cell'>ยอดรวม</div>
                      <div className='table-summary-cell aligh-right'>
                        ฿{' '}
                        {Number(order.summary_net || order.shop_total).toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })}
                      </div>
                    </div>

                    {order.order_status === 'PC_RTN_RCV' ? (
                      <>
                        <div className='d-flex justify-content-between py-0 mt-2 text-danger'>
                          <div className='table-summary-cell'>ยอดคืนสินค้ารวม</div>
                          <div className='table-summary-cell aligh-right'>
                            ฿{' '}
                            {Number(order.return_shop_subtotal).toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className='d-flex justify-content-between py-0'>
                          <div className='table-summary-cell'>ยอดหลังคืนสินค้า</div>
                          <div className='table-summary-cell aligh-right'>
                            ฿{' '}
                            {Number(order.return_shop_total).toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className='d-flex justify-content-between py-0'>
                          <div className='table-summary-cell'>ค่าธรรมเนียม</div>
                          <div className='table-summary-cell aligh-right'>
                            ฿{' '}
                            {Number(order.return_shop_servicecharge).toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className='d-flex justify-content-between py-0 border-bottom text-success'>
                          <div className='table-summary-cell'>ยอดของร้าน</div>
                          <div className='table-summary-cell aligh-right'>
                            ฿{' '}
                            {Number(order.return_shop_income).toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        {order.income_paid === true ? (
                          <div className='d-flex justify-content-between py-0 border-bottom text-success'>
                            <div className='table-summary-cell'>โอนจ่ายแล้ว</div>
                          </div>
                        ) : null}
                      </>
                    ) : null}
                    {order.order_status === 'PC_RCV' ? (
                      <>
                        <div className='d-flex justify-content-between py-0 mt-2'>
                          <div className='table-summary-cell'>ค่าธรรมเนียม</div>
                          <div className='table-summary-cell aligh-right'>
                            ฿{' '}
                            {Number(order.shop_servicecharge).toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className='d-flex justify-content-between py-0 border-bottom text-success'>
                          <div className='table-summary-cell'>ยอดของร้าน</div>
                          <div className='table-summary-cell aligh-right'>
                            ฿{' '}
                            {Number(order.shop_income).toLocaleString(undefined, {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        {order.income_paid === true ? (
                          <div className='d-flex justify-content-between py-0 border-bottom text-success'>
                            <div className='table-summary-cell'>โอนจ่ายแล้ว</div>
                          </div>
                        ) : null}
                      </>
                    ) : null}
                  </div>
                </div>
                {order.order_status === 'PC_RTN_RCV' ? (
                  <div className='d-block pt-0 pb-2 flex-wrap border-top'>
                    <div className='d-block  mt-2'>
                      <div className='editname pr-5 text-danger'>เหตุผลในการขอคืนสินค้า</div>
                      <div className='editname pr-5'>{order.return_reason}</div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ))
        ) : (
          <div className='col-md-12'>
            <div className='empty-state-container'>
              <div className='empty-state-icon'>
                <i className='fas fa-history'></i>
              </div>
              <div className='empty-state-title font-th'>ไม่มีประวัติการขาย</div>
              <div className='empty-state-text font-th'>ยังไม่พบข้อมูลการขายในเดือนที่เลือก</div>
            </div>
          </div>
        )}
      </div>

      <div className='d-flex'>
        <ReactPaginate
          breakLabel='...'
          nextLabel='>'
          onPageChange={handlePageClick_onsell}
          pageRangeDisplayed={10}
          pageCount={pageCount_onsell}
          previousLabel='<'
          renderOnZeroPageCount={null}
        />
      </div>

      <div
        className='delivery-timeline-box'
        style={{ display: modal_delivery_timeline ? 'block' : 'none' }}
      >
        <div className='delivery-timeline-box-header'>
          <div className='d-block'>
            <div className='timeline-box-header-title'>
              <i className='mdi mdi-truck-fast-outline text-primary font-size-16'></i>{' '}
              สถานะของการขนส่งสินค้า
            </div>
            <div className='timeline-box-header-order text-success'>
              เลขที่คำสั่งซื้อ {orderselect.order_id}
            </div>
          </div>
          <i
            className='fe-x text-dark mouse-pointer'
            onClick={() => {
              setmodal_delivery_timeline(false);
            }}
          ></i>
        </div>
        {shipping_timeline.states !== undefined ? (
          shipping_timeline.states.length > 0 ? (
            <div className='delivery-timeline-box-wrapper'>
              <div className='vertical-timeline vertical-timeline--animate vertical-timeline--one-column'>
                {shipping_timeline.states !== undefined
                  ? shipping_timeline.states.map((states, index) => (
                      <div className='vertical-timeline-item vertical-timeline-element'>
                        <div>
                          <span className='vertical-timeline-element-icon bounce-in'>
                            <i className='badge badge-dot badge-dot-xl badge-primary'> </i>
                          </span>
                          <div className='vertical-timeline-element-content bounce-in'>
                            <p>{states.datetime}</p>
                            <h4 className='timeline-title'>{states.description}</h4>
                            <p>{states.location}</p>
                          </div>
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            </div>
          ) : (
            <div className='noproductdisplay'>
              <i className='fas fa-info-circle text-primary mr-2'></i> ไม่มีข้อมูลการขนส่งที่จะแสดง
            </div>
          )
        ) : (
          <div className='noproductdisplay'>
            <i className='fas fa-info-circle text-primary mr-2'></i> ไม่มีข้อมูลการขนส่งที่จะแสดง
          </div>
        )}
      </div>
      <ModalLoad option={modal_load}></ModalLoad>
      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
      <BtnGogo></BtnGogo>
    </div>
  );
}

export default MyShop_Seller_History;
